import { render, staticRenderFns } from "./platform_bill.vue?vue&type=template&id=11d149fa&scoped=true&"
import script from "./platform_bill.vue?vue&type=script&lang=ts&"
export * from "./platform_bill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d149fa",
  null
  
)

export default component.exports